import { request, queryString } from '../../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/fvp/clients/fundings'

export default {
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  listAll (id) {
    return request(`${url}/list/all/${id}`)
  },
  listClientFunders (id) {
    return request(`${url}/list/client/${id}`)
  },
  listClientAvailableFunders (id) {
    return request(`${url}/list/funder/${id}`)
  },
  listClientFundingPeriod (clientId, funderId) {
    return request(`${url}/list/client-period/${clientId}/${funderId}`)
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },

}
